import type { FaireProductEntity } from "../../entity_types/product";

export const p_pgdtd2464j: FaireProductEntity = {
  token: "p_pgdtd2464j",
  type: "product",
  name: "EPHEMERAL MAGNETIC LIST PAD PREPACK",
  brandName: "Punch Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/90ab68b41444d8adf7d8aa3cddf45714508eefdfb974c8999db63e85f4d6e052.jpeg",
  priceDollars: 120,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/47890fbac27e22e36af1105b6dc3d0219aa946ad979757db165e60a4b41dfe7d.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
